<template>
  <div class="dialog-delete">
    <component
      ref="dialog"
      :is="dialog"
      v-bind="$attrs"
      v-on="$listeners"
      @agree="onAgree"
    ></component>
  </div>
</template>

<script>

export default {
  name: 'DialogDelete',
  inheritAttrs: false,
  components: {
    'dialog-confirm': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogConfirm'),
    'dialog-alert': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogAlert')
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    dialog () {
      return 'dialog-confirm'
    }
  },
  methods: {
    // USER INTERFACE
    show () {
      this.$refs.dialog.show(...arguments)
    },
    hide () {
      this.$refs.dialog.hide(...arguments)
    },
    // END INTERFACE
    onAgree () {
      this.$emit('hide', ...arguments)
    }
  }
}
</script>
